import { PageHero, SHELL, Reveal } from "@/components/bits";

export default function Legal() {
    return (
        <div data-testid="legal-page">
            <PageHero label="LEGAL" title={"TERMS & PRIVACY"} sub="The plain-weather legal basics of using this website." />
            <section className="py-20 md:py-28">
                <SHELL>
                    <div className="max-w-3xl mx-auto space-y-16">
                        <Reveal>
                            <div id="terms" className="scroll-mt-28">
                                <h2 className="text-2xl font-black tracking-tight mb-6">TERMS</h2>
                                <div className="space-y-4 text-sm text-vera-mut leading-relaxed">
                                    <p>This website describes the VERA protocol, which is under development. Content is provided for information only and may change as the infrastructure evolves.</p>
                                    <p>Nothing on this website is an offer to sell, a solicitation, or investment, legal, tax or accounting advice. No returns, yields or performance are promised, and no asset presented here is risk-free.</p>
                                    <p>External links are provided for verification of sources. VERA does not control third-party websites and is not responsible for their content.</p>
                                    <p>The VERA token is COMING SOON. No contract address has been published. Any address claiming to represent VERA is unofficial.</p>
                                </div>
                            </div>
                        </Reveal>
                        <Reveal delay={0.06}>
                            <div id="privacy" className="scroll-mt-28">
                                <h2 className="text-2xl font-black tracking-tight mb-6">PRIVACY</h2>
                                <div className="space-y-4 text-sm text-vera-mut leading-relaxed">
                                    <p>This website does not require an account and does not collect personal data through its own forms. Standard, anonymous analytics may be used to understand aggregate traffic.</p>
                                    <p>Third-party services linked from this site (such as X, Circle or Argus) are governed by their own privacy policies.</p>
                                    <p>For privacy questions, reach the project through the official X account: @VeraOnArc.</p>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </SHELL>
            </section>
        </div>
    );
}
